import { render, staticRenderFns } from "./AdminBrandlist.vue?vue&type=template&id=77b18f12"
import script from "./AdminBrandlist.vue?vue&type=script&lang=js"
export * from "./AdminBrandlist.vue?vue&type=script&lang=js"
import style0 from "./AdminBrandlist.vue?vue&type=style&index=0&id=77b18f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports